<template>
  <div>
    <div class="Grant">
      <div class="Grantbox">
        <div class="Granttit">
          DO Grant Program<br />
          Application
        </div>
        <div class="Granttit1" style="line-height: 23px">
          Hello, DO developers!
        </div>
        <div class="Granttit1">
          Thank you so much for your great<br />
          contribution to the DO ecology!
        </div>
        <div class="Granttit2">
          DO ecology application is a significant part<br />
          of DO network, we appreciate your work and<br />
          look forward to getting in touch with you!
        </div>

        <img src="../../../assets/pc/pr.png" />
        <div class="Granttit2">
          We’ve been offering various kinds of support to<br />
          help developers to build and run their <br />applications on DO with a
          grant program from<br />
          DO foundation, if you’ve developed a DO<br />
          application, please submit your application in <br />the following
          table, and we will contact you<br />
          soon!
        </div>
        <div class="Granttit3">
          DO Application Grant<br />
          Submission
        </div>
        <div class="Grantform">
          <!-- <div class="Grantformtit">DO network application submission</div> -->
          <div class="Grantformbox">
            <el-form
              :rules="rules"
              ref="grantForm"
              :model="form"
              class="custom-form"
            >
              <!-- 应用名称 -->
              <el-form-item prop="name" class="form-item-vertical">
                <template #label>
                  1. Name of your application<span class="required">*</span>
                </template>
                <el-input v-model="form.name" placeholder="Name" />
              </el-form-item>

              <!-- 应用类型（下拉框） -->
              <el-form-item prop="type" class="form-item-vertical">
                <template #label>
                  2. Type of your application<span class="required">*</span>
                </template>
                <el-select
                  v-model="form.type"
                  placeholder="Please select a type"
                  popper-class="custom-dropdown"
                >
                  <el-option
                    label="wallet"
                    value="wallet"
                    style="padding-left: 20px"
                  />
                  <el-option
                    label="swap"
                    value="swap"
                    style="padding-left: 20px"
                  />
                  <el-option
                    label="bridge"
                    value="bridge"
                    style="padding-left: 20px"
                  />
                  <el-option
                    label="stake"
                    value="stake"
                    style="padding-left: 20px"
                  />
                  <el-option
                    label="NFT"
                    value="NFT"
                    style="padding-left: 20px"
                  />
                  <el-option
                    label="gamefi"
                    value="gamefi"
                    style="padding-left: 20px"
                  />
                  <el-option
                    label="socialfi"
                    value="socialfi"
                    style="padding-left: 20px"
                  />
                  <el-option label="AI" value="AI" style="padding-left: 20px" />
                  <el-option
                    label="meme coin"
                    value="meme coin"
                    style="padding-left: 20px"
                  />
                  <el-option
                    label="others"
                    value="others"
                    style="padding-left: 20px"
                  />
                </el-select>
              </el-form-item>

              <!-- 官方网站 -->
              <el-form-item prop="website" class="form-item-vertical">
                <template #label>
                  3. Official website<span class="required">*</span>
                </template>
                <el-input
                  v-model="form.website"
                  placeholder="Please enter your Official website"
                />
              </el-form-item>

              <!-- 邮箱 -->
              <el-form-item prop="email" class="form-item-vertical">
                <template #label>
                  4. Email<span class="required">*</span>
                </template>
                <el-input
                  v-model="form.email"
                  type="email"
                  placeholder="Please enter email"
                />
              </el-form-item>

              <!-- 社交媒体链接 -->
              <el-form-item prop="social" class="form-item-vertical">
                <template #label
                  >5. Social media link
                  (X/Discord/Telegram/Medium/Github,etc.)<span class="required"
                    >*</span
                  >
                </template>
                <el-input v-model="form.social" placeholder="Please fill in" />
              </el-form-item>

              <!-- 支持类型（下拉框） -->
              <el-form-item prop="support" class="form-item-vertical">
                <template #label>
                  6. Which kind of support do you need ? (Multiple Selection)
                  <span class="required">*</span>
                </template>
                <el-checkbox-group
                  size="small"
                  @change="statusChangea"
                  v-model="form.support"
                >
                  <el-checkbox
                    label="Funds support"
                    name="Funds support"
                  ></el-checkbox>

                  <el-checkbox
                    label="Develop support"
                    name="Develop support"
                  ></el-checkbox>
                  <el-checkbox
                    label="Promotion/Operation support"
                    name="Promotion/Operation support"
                  ></el-checkbox>
                  <el-checkbox
                    label="Resource support"
                    name="Resource support"
                  ></el-checkbox>
                  <el-checkbox
                    label="Design/Content support"
                    name="Design/Content support"
                  ></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="other" class="form-item-vertical">
                <el-input v-model="form.other" placeholder="Others" />
              </el-form-item>

              <!-- 期望资金 -->
              <el-form-item prop="fund" class="form-item-vertical">
                <template #label>
                  7. How much fund do you expect from the grant(in dollar)<span
                    class="required"
                    >*</span
                  >
                </template>
                <el-input
                  v-model="form.fund"
                  placeholder="Please enter quantity"
                />
              </el-form-item>

              <!-- 资金用途 -->
              <el-form-item prop="usage" class="form-item-vertical">
                <template #label>
                  8. How will you use the grant?<span class="required">*</span>
                </template>
                <el-input
                  v-model="form.usage"
                  type="textarea"
                  placeholder="Please enter "
                />
              </el-form-item>

              <!-- 应用简介 -->
              <el-form-item prop="appIntro" class="form-item-vertical">
                <template #label>
                  9. A brief introduction of your application<span
                    class="required"
                    >*</span
                  >
                </template>
                <el-input
                  v-model="form.appIntro"
                  type="textarea"
                  placeholder="Including the problem that your application solves, how it makes profit, your alternatives, the current stage of the application, if the application has been running on other L1 or L2, etc."
                />
              </el-form-item>

              <!-- 团队简介 -->
              <el-form-item prop="teamIntro" class="form-item-vertical">
                <template #label>
                  10. A brief introduction of your team<span class="required"
                    >*</span
                  >
                </template>
                <el-input
                  v-model="form.teamIntro"
                  type="textarea"
                  placeholder="Please fill in"
                />
              </el-form-item>

              <!-- 路线图 -->
              <el-form-item prop="roadmap" class="form-item-vertical">
                <template #label>
                  11. Brief Roadmap(key time points)<span class="required"
                    >*</span
                  >
                </template>
                <el-input
                  v-model="form.roadmap"
                  type="textarea"
                  placeholder="Please fill in"
                />
              </el-form-item>

              <!-- 其他材料 -->
              <el-form-item class="form-item-vertical">
                <template #label>
                  12. Other materials of your application</template
                >
                <el-input
                  v-model="form.otherMaterials"
                  type="textarea"
                  placeholder="whitepaper, technique doc, media news, etc."
                />
              </el-form-item>
              <div class="tips"><span>" * "</span> are required fields</div>
              <div class="buttons" @click="handleSubmit">Submit</div>
              <!-- 提交按钮 -->
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog" v-if="dialogVisible">
      <div class="dialogbox">
        <img src="@/assets/pc/succ.png" />
        <div class="dialogtit">submit successfully</div>
        <div class="btn" @click="handleClose">OK</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Getadd } from "@/assets/server/api";
// import Canvas from "@/components/pc/canvas.vue";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        name: "",
        type: "",
        website: "",
        email: "",
        support: [],
        other: "",
        fund: "",
        usage: "",
        appIntro: "",
        teamIntro: "",
        roadmap: "",
        otherMaterials: "",
      },
      rules: {
        name: [
          { required: true, message: "Name is required", trigger: "blur" },
          {
            max: 200,
            message: "Name cannot exceed 200 characters",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "Type is required", trigger: "change" },
          {
            max: 255,
            message: "Type cannot exceed 255 characters",
            trigger: "blur",
          },
        ],
        website: [
          { required: true, message: "Website is required", trigger: "blur" },
          {
            max: 500,
            message: "Website cannot exceed 500 characters",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "Email is required", trigger: "blur" },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
          {
            max: 200,
            message: "Email cannot exceed 200 characters",
            trigger: "blur",
          },
        ],
        social: [
          { required: true, message: "Social is required", trigger: "blur" },
          {
            max: 500,
            message: "Social cannot exceed 500 characters",
            trigger: "blur",
          },
        ],
        other: [
          {
            validator: this.validateOther,
            trigger: "blur",
          },
          {
            max: 200,
            message: "Support type cannot exceed 200 characters",
            trigger: "blur",
          },
        ],
        fund: [
          {
            required: true,
            message: "Expected fund is required",
            trigger: "blur",
          },
          {
            max: 200,
            message: "Fund cannot exceed 200 characters",
            trigger: "blur",
          },
        ],
        usage: [
          {
            required: true,
            message: "Grant usage is required",
            trigger: "blur",
          },
          {
            max: 5000,
            message: "Usage cannot exceed 5000 characters",
            trigger: "blur",
          },
        ],
        appIntro: [
          {
            required: true,
            message: "Application introduction is required",
            trigger: "blur",
          },
          {
            max: 5000,
            message: "Application introduction cannot exceed 5000 characters",
            trigger: "blur",
          },
        ],
        teamIntro: [
          {
            required: true,
            message: "Team introduction is required",
            trigger: "blur",
          },
          {
            max: 5000,
            message: "Team introduction cannot exceed 5000 characters",
            trigger: "blur",
          },
        ],
        roadmap: [
          { required: true, message: "Roadmap is required", trigger: "blur" },
          {
            max: 5000,
            message: "Roadmap cannot exceed 5000 characters",
            trigger: "blur",
          },
        ],
        otherMaterials: [
          {
            max: 5000,
            message: "Other materials cannot exceed 5000 characters",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 自定义校验方法
    validateOther(rule, value, callback) {
      const { support, other } = this.form;

      // 当 support 为空时，要求 other 必填
      if (support.length === 0 && !other) {
        callback(new Error("Other is required when support is not selected"));
      } else {
        callback(); // 校验通过
      }
    },
    statusChangea(value) {
      //   console.log(value);
      if (this.form.support.length > 1) {
        this.form.support = value;
        // this.form.support= this.form.support.join()
        // console.log(this.form.support)
      }
    },
    async handleSubmit() {
      console.log(123123);
      this.$refs.grantForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error("Please fill in the required fields.");
          return;
        }

        // Ensure loading state
        this.loading = true;

        try {
          // Prepare the combined 'support' and 'other' fields
          const combinedSupport = [...this.form.support, this.form.other]
            .filter(Boolean) // Filter out empty values
            .join(", ");

          // Add combined support to form data
          this.form.combinedSupport = combinedSupport;

          // Prepare FormData
          const formData = new FormData();
          for (const [key, value] of Object.entries(this.form)) {
            formData.append(key, value);
          }

          // Call API with FormData
          let data = await Getadd(formData);

          if (data.code == 0) {
            this.$message.success("Form submitted successfully!");
            this.dialogVisible = true;
            console.log(this.form); // Log form data for verification
          }
        } catch (error) {
          this.$message.error("Submission failed. Please try again.");
          console.error("Submission Error:", error);
        } finally {
          this.loading = false; // Reset loading state
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.form.name = "";
      this.form.type = "";
      this.form.website = "";
      this.form.email = "";
      this.form.social = "";
      this.form.support = [];
      this.form.fund = "";
      this.form.usage = "";
      this.form.appIntro = "";
      this.form.other = "";
      this.form.teamIntro = "";
      this.form.roadmap = "";
      this.form.otherMaterials = "";
    },
    handleConfirm() {
      this.dialogVisible = false; // Hide the dialog on confirm
    },
  },
};
</script>
<style>
/deep/.el-form-item.is-requiredbefore {
  display: none;
}
/deep/.el-form-item__label:before {
  content: "" !important;
}
/deep/.el-input__inner {
  width: 1110px !important;
}
/deep/ .el-select-dropdown__item:hover {
  background-color: #99b2f2 !important; /* 选中项背景 */
  color: #4573e7 !important; /* 选中项文字颜色 */
}

/* 针对当前选中项的样式 */
/deep/.el-select-dropdown__item.selected {
  background-color: #99b2f2 !important; /* 选中项背景 */
  color: #4573e7 !important; /* 选中项文字颜色 */
}
</style>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.Grant {
  width: 750px;
  overflow: hidden;
  background: #fff;
  .Grantbox {
    width: 750px;
    margin: 0 auto;

    .Granttit {
      margin-top: 180px;
      // height: 112px;
      font-family: Poppins, Poppins;
      font-weight: 900;
      font-size: 64px;
      color: #000000;
      word-spacing: 0px;
      text-align: center;
      margin-bottom: 100px;
    }
    .Granttit1 {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 32px;
      color: #000000;
      line-height: 53px;
      text-align: center;
      margin-bottom: 20px;
    }
    .Granttit2 {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 27px;
      color: #61666b;
      line-height: 43px;
      text-align: center;
      margin-top: 20px;
    }
    img {
      width: 648px;
      height: 191px;
      margin-left: 51px;
      margin-top: 67px;
      margin-bottom: 67px;
    }
    .Granttit3 {
      margin-top: 159px;
      text-align: center;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 40px;
      color: #000000;
      margin-bottom: 40px;
    }
    .Grantform {
      width: 750px;

      background: #fafafa;
      border-radius: 5px 5px 5px 5px;
      // border: 1px solid #e3e3e3;
      margin: 0 auto;
      margin-bottom: 40px;
      .Grantformtit {
        height: 25px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 27px;
        color: #000000;
        line-height: 43px;
        text-align: center;
        padding-top: 53px;
        margin-left: 40px;
      }
      .Grantformbox {
        margin-top: 83px;
        // margin-left: 40px;
        .custom-form {
          max-width: 690px;
          margin: 0 auto;
          // padding: 20px;
          // border: 1px solid red;
          border-radius: 8px;
          // background-color: #fff;

          .form-item-vertical {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 16px;
            width: 690px; /* Ensures each form item takes full width */
            // border: 1px solid yellow;

            /deep/ .el-input,
            .el-select {
              width: 100%; /* Full width for the input fields */
              width: 690px; /* Optional: limit the input width */
              height: 90px;
              line-height: 90px;

              //border: 1px solid green;
            }
            /deep/.el-form-item__label {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 27px;
              color: #3a3f49;
              line-height: 43px;
              text-align: left;
              margin-bottom: 20px;
              margin-top: 38px;
              // border: 1px solid red;
              width: 690px;
            }
            /deep/.el-form-item__label:before {
              content: "" !important;
            }
            /deep/ .el-textarea {
              width: 690px;
              height: 400px;
              // border: 1px solid yellow;
            }
            /deep/.el-input__inner {
              height: 90px !important;
            }

            /deep/ .el-textarea__inner {
              height: 400px !important; /* Ensure the inner elements fill the container */
              // border: 1px solid green;
            }
            /deep/.el-select-dropdown__list {
              border: 1px solid red !important;
            }

            /deep/.el-select-dropdown__item {
              min-height: 90px !important;
              line-height: 90px !important;
              border: 1px solid red;
              padding-left: 20px !important;
              span {
                border: 1px solid red;
              }
            }
            /deep/ .el-select-dropdown__item:hover {
              background-color: #99b2f2 !important; /* 选中项背景 */
              color: #4573e7 !important; /* 选中项文字颜色 */
            }
            /deep/.el-checkbox__input {
              margin-right: 4px;
            }

            /* 针对当前选中项的样式 */
            ::v-deep(.el-select-dropdown__item.selected) {
              background-color: #99b2f2 !important; /* 选中项背景 */
              color: #4573e7 !important; /* 选中项文字颜色 */
              //  border: 1px solid red;
            }

            .required {
              color: red;
              margin-left: 4px;
            }
          }

          .tips {
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 19px;
            color: #2c1d1a;
            line-height: 33px;
            margin-top: 40px;
            margin-bottom: 18px;
            span {
              color: #e74545;
            }
          }
          .buttons {
            width: 650px;
            height: 90px;
            line-height: 90px;
            background: #4573e7;
            border-radius: 10px 10px 10px 10px;
            border: 2px solid #285de2;

            text-align: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 30px;
            color: #ffffff;
            cursor: pointer;
            margin-top: 27px;
            margin-bottom: 147px;
          }
        }
      }
    }
  }
}
.dialog {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;

  width: 100%;
  height: 100%;
  overflow: auto;
  .dialogbox {
    width: 385px;
    height: 220px;
    background: #f4f5f7;
    border-radius: 0px 0px 0px 0px;
    border-top: 10px solid #4573e7;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 60px;
      height: 60px;
      margin-left: 163px;
      margin-top: 24px;
    }
    .dialogtit {
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 16px;
      color: #2b2d41;
      line-height: 22px;
      margin-top: 16px;
      text-align: center;
    }
    .btn {
      width: 145px;
      height: 40px;
      line-height: 40px;
      background: #4573e7;
      border-radius: 5px 5px 5px 5px;
      text-align: center;
      cursor: pointer;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      margin-top: 26px;
      margin-left: 120px;
    }
  }
}
</style>
